<template>
  <emd-modal
    has-header
    has-footer
    :open="isOpen"
    @close="$emit('onClose')"
  >
    <template v-slot:header>
      <h2 class="emd-text _size_section _color_contrast">
        {{ $t('modal.pix.modal-create-key.title') }}
      </h2>
    </template>
    <template v-slot:content>
      <emd-alert
        variant="danger"
        :title="$t('alert.error-title')"
        v-if="error"
        @cancel="error = null"
      >
        <template slot="content">
          {{ error }}
        </template>
      </emd-alert>
      <jade-checkbox
        id="create-key-checkbox"
        name="create-key-checkbox"
        :value.sync="isCheck"
        :label="$t('modal.pix.modal-create-key.paragraph-1')"
      />
      <password-confirmation
        name="input-password"
        data-testid="input-password"
        v-model="password"
        class="eu-mt_5"
      />
    </template>
    <template v-slot:footer>
      <div class="eu-flex-item eu-align_right">
        <emd-button
          data-testid="button-cancel"
          type="text"
          :disabled="isValidate"
          @click="$emit('onCancel')"
        >
          {{ $t('modal.pix.modal-create-key.button-cancel') }}
        </emd-button>
        <emd-button
          color="primary"
          data-testid="button-confirm"
          @click="onSubmit()"
          :disabled="isValidate"
        >
          <emd-loader
            v-if="isLoad"
            :type="''"
          ></emd-loader>
          <span v-if="!isLoad">
            {{ $t('modal.pix.modal-create-key.button-confirm') }}
          </span>
        </emd-button>
      </div>
    </template>
  </emd-modal>
</template>

<script>
import {
  EmdModal,
  EmdButton,
  EmdAlert,
  EmdLoader
} from 'emerald-vue/src/components'
import { JadeCheckbox } from '@jade'
import PasswordConfirmation from '@/components/project/molecules/PasswordConfirmation.vue'

export default {
  name: 'ModalCreateKey',
  components: {
    EmdModal,
    PasswordConfirmation,
    EmdButton,
    EmdAlert,
    EmdLoader,
    JadeCheckbox
  },
  props: {
    isOpen: {
      type: Boolean
    },
    isLoad: {
      type: Boolean,
      required: true
    },
    error: [String, null]
  },
  data () {
    return {
      password: '',
      isCheck: false
    }
  },
  methods: {
    onSubmit () {
      this.$emit('onSubmit', window.btoa(this.password))
    }
  },
  computed: {
    isValidate () {
      return !this.isCheck || !this.password || this.isLoad
    }
  }
}
</script>
